import { render } from "./LogActivityComponent.vue?vue&type=template&id=ebb84e4e"
import script from "./LogActivityComponent.vue?vue&type=script&lang=js"
export * from "./LogActivityComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__